import { render, staticRenderFns } from "./AppLayoutFormPagoDaAumento.vue?vue&type=template&id=5a7f0f19&"
import script from "./AppLayoutFormPagoDaAumento.vue?vue&type=script&lang=js&"
export * from "./AppLayoutFormPagoDaAumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
